<template>
  <div class="page about">
    <b-container>
      <section class="section">
        <h1 class="h1 bold mb-2">Chi siamo</h1>
        <p>
          La nostra società è leader in Italia nella fornitura di soluzioni business di online
          travel booking. Le nostre soluzioni vengono utilizzate da alcune tra le più innovative
          aziende italiane nel welfare aziendale, nel marketing, nei piani loyalty e nelle
          incentivazioni aziendali al trade.
        </p>
        <p>
          Ci avvaliamo di avanzate tecnologie IT e di collaborazioni con i leader globali del travel
          online ma manteniamo anche una caratterizzazione territoriale. Infatti, tutto il nostro
          staff, dallo sviluppo tecnologico all'assistenza clienti passando per lo sviluppo
          strategico e commerciale, si trova nella nostra sede in provincia di Rimini.
        </p>
      </section>
      <section class="section">
        <b-row>
          <b-col md="6" class="text-center">
            <img src="assets/about/about-1.jpg" />
          </b-col>
          <b-col md="6">
            <h2 class="h3 bold">La nostra mission</h2>
            <p>
              La nostra mission è quella di realizzare soluzioni di travel booking fortemente
              orientate all'utente.
            </p>
            <p>
              Lo sviluppo tecnologico e la cura dell'assistenza clienti danno sicurezza e
              tranquillità ai viaggiatori che prenotano con
              {{ site.brand }}. Le aziende che affidano i loro dipendenti e i loro clienti ai nostri
              servizi sanno di poter contare su un servizio a loro dedicato che non trova riscontro
              negli altri player del settore.
            </p>
          </b-col>
        </b-row>
      </section>

      <section class="section">
        <hr />
      </section>

      <!--<section class="section">
        <ul class="bullet-points-with-icon">
          <li>
            <div class="bullet-points-with-icon--icon" v-html="medal"></div>
            <div class="bullet-points-with-icon--content">Elenco Puntato in fascia orizzontale con icona</div>
          </li>
          <li>
            <div class="bullet-points-with-icon--icon" v-html="medal"></div>
            <div class="bullet-points-with-icon--content">Elenco Puntato in fascia orizzontale con icona</div>
          </li>
          <li>
            <div class="bullet-points-with-icon--icon" v-html="medal"></div>
            <div class="bullet-points-with-icon--content">Elenco Puntato in fascia orizzontale con icona</div>
          </li>
        </ul>
      </section>

      <section class="section">
        <hr />
      </section>-->

      <section class="section">
        <div class="quote">
          <div class="quote--icon" v-html="quote"></div>
          <div class="quote--title">{{ site.payoff }} {{ site.brand }}</div>
          <div class="quote--content">
            {{ site.payoff }} {{ site.brand }} è un sito di prenotazione voli facile e semplice da
            usare che ti permette di avere accesso ai servizi proposti sui circuiti internazionali
            da tutte le principali compagnie aeree tradizionali e low cost in Italia, in Europa e
            nel mondo.
          </div>
        </div>
      </section>

      <section class="section">
        <b-row>
          <b-col md="6">
            <h2 class="h2 bold mb-2">Contatti</h2>
            <h2 class="h3">{{ site.payoff }} {{ site.brand }} è un servizio di Salabam srl</h2>
            <!--<p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
            </p>-->
            <br />
            <ul class="dashed">
              <li>
                <b>Assistenza clienti:</b>
                <a :href="'mailto:' + site.emailSupport">{{ site.emailSupport }}</a>
              </li>
              <li v-if="site.emailBusiness != ''">
                <b>Servizi business:</b>
                <a :href="'mailto:' + site.emailBusiness">{{ site.emailBusiness }}</a>
              </li>
              <li><b>Telefono:</b> {{ site.phoneNumber }}</li>
              <li v-if="site.waIntentLink != '' && site.mobileNumber != ''">
                <b>Whatsapp:</b> <a :href="site.waIntentLink">{{ site.mobileNumber }}</a>
              </li>
              <li v-else-if="site.mobileNumber != ''"><b>Whatsapp:</b> {{ site.mobileNumber }}</li>
            </ul>
          </b-col>
          <b-col md="6" class="text-center">
            <img src="assets/about/about-2-2.jpg" />
          </b-col>
        </b-row>
      </section>

      <!--<section class="section text-center">
          <b-row>
            <b-col sm="6" md="4" lg="2">
              <div v-html="medal"></div>
              <p class="mx-4 mt-2">
                Titolo
                <br>
                Testo descrittivo del servizio o punto.
              </p>
            </b-col>
            <b-col sm="6" md="4" lg="2">
              <div v-html="medal"></div>
              <p class="mx-4 mt-2">
                Titolo
                <br>
                Testo descrittivo del servizio o punto.
              </p>
            </b-col>
            <b-col sm="6" md="4" lg="2">
              <div v-html="medal"></div>
              <p class="mx-4 mt-2">
                Titolo
                <br>
                Testo descrittivo del servizio o punto.
              </p>
            </b-col>
            <b-col sm="6" md="4" lg="2">
              <div v-html="medal"></div>
              <p class="mx-4 mt-2">
                Titolo
                <br>
                Testo descrittivo del servizio o punto.
              </p>
            </b-col>
            <b-col sm="6" md="4" lg="2">
              <div v-html="medal"></div>
              <p class="mx-4 mt-2">
                Titolo
                <br>
                Testo descrittivo del servizio o punto.
              </p>
            </b-col>
            <b-col sm="6" md="4" lg="2">
              <div v-html="medal"></div>
              <p class="mx-4 mt-2">
                Titolo
                <br>
                Testo descrittivo del servizio o punto.
              </p>
            </b-col>
          </b-row>
      </section>-->

      <section class="section">
        <hr />
      </section>
    </b-container>
  </div>
</template>

<script>
import { medal, quote } from '@/components/svg/common';
import Vue from 'vue';

export default {
  name: 'about',
  components: {},
  props: {
    footerMenu: String,
    btnText: String,
  },
  created() {
    this.medal = medal;
    this.quote = quote;
  },
  data() {
    return {
      site: Vue.prototype.$config.site,
    };
  },
  computed: {},
};
</script>

<style lang="scss">
.about {
  ul {
    margin: 0;

    li {
      margin-bottom: 10px;
    }
  }

  ul.dashed {
    list-style-type: none;
  }

  ul.dashed > li {
    /*text-indent: -5px;*/
  }

  ul.dashed > li:before {
    content: '-';
    /*text-indent: -5px;*/
  }
}
</style>
